export { FaqSection } from './FaqSection'
